import {
    Box,
    Typography,
    Pagination,
    PaginationItem,
    Select,
    MenuItem,
} from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const CommonPagination = ({
    page,
    rowsPerPage,
    totalItems,
    totalPages,
    onPageChange,
    onRowsPerPageChange,
}) => {
    return (
        <>
            {totalItems > 10 && (
                <Box
                    className="pagination"
                    display="flex"
                    borderTop="1px solid #ccc"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ padding: "20px 16px", backgroundColor: "#fff" }}
                >
                    {/* Results info */}
                    <Typography variant="body2">
                        Showing Results{" "}
                        {Math.min((page - 1) * rowsPerPage + rowsPerPage, totalItems)} of{" "}
                        {totalItems}
                    </Typography>

                    {/* Page navigation */}
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(_, value) => onPageChange(value)}
                        renderItem={(item) => (
                            <PaginationItem
                                {...item}
                                slots={{
                                    previous: () => (
                                        <Box className="d-flex align-items-center gap-2">
                                            <KeyboardArrowLeft />
                                            <Typography className="border-bottom" variant="body2">
                                                Previous
                                            </Typography>
                                        </Box>
                                    ),
                                    next: () => (
                                        <Box className="d-flex align-items-center gap-2">
                                            <Typography className="border-bottom" variant="body2">
                                                Next
                                            </Typography>
                                            <KeyboardArrowRight />
                                        </Box>
                                    ),
                                }}
                                sx={{
                                    "&.Mui-selected": {
                                        backgroundColor: "black",
                                        color: "white",
                                        "&:hover": { backgroundColor: "#333" },
                                    },
                                }}
                            />
                        )}
                    />

                    {/* Rows per page */}
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="body2">Items per Page:</Typography>
                        <Select
                            size="small"
                            value={rowsPerPage}
                            onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
                            sx={{ height: "32px", bgcolor: "#0000005A" }}
                        >
                            {[10, 25, 50, 100].map((num) => (
                                <MenuItem key={num} value={num}>
                                    {num}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default CommonPagination;
